import { Typography } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { colors, responsive } from '@/utils';

/** Anchor for the count badge that sits on the top-right corner of the bell. */
export const StyledAlertBellAnchor = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
`;

/**
 * Sits on the bell's top-right corner, slightly past the button's right edge. Kept inside the
 * bell's box vertically so it clears the focused widget's border.
 */
export const StyledAlertCount = styled(Typography)`
  position: absolute;
  top: 0;
  right: -0.375rem;
  min-width: ${responsive.spacing['3xlarge']};
  padding: 0;
  box-sizing: border-box;
  border-radius: ${responsive.radius.rounded};
  background-color: ${colors.palette.white[400]};
  color: ${colors.palette.white[1000]};
  /* Keeps the white number readable over bright video frames. */
  text-shadow: 0 0 0.125rem ${colors.palette.neutral.dark[750]};
  text-align: center;
  pointer-events: none;
`;

export const StyledAlertMenuList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${responsive.spacing.xsmall};
  max-width: 22rem;
  margin: 0;
  padding: ${responsive.spacing.small};
  list-style: none;
`;

export const StyledAlertMenuItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${responsive.spacing.small};
  padding: ${responsive.spacing.small};
  border-radius: ${responsive.radius.small};
  outline: none;

  &:focus-visible {
    box-shadow: inset 0 0 0 2px ${colors.stroke.focused};
  }
`;
